export const mainSystem = [
  'Volume 1 — First 20 Swim Lessons: Beginner Foundations & Water Confidence',
  'Volume 2 — Floating & Breathing: 15 Ready-to-Teach Lessons',
  'Volume 3 — Freestyle: 20 Ready-to-Teach Lessons',
  'Volume 4 — Backstroke, Breaststroke & Butterfly: 25 Ready-to-Teach Lessons',
  'Volume 5 — Mixed-Level Groups & Class Management: 20 Ready-to-Teach Lessons',
  'Volume 6 — Swim Conditioning, Endurance & Progressive Training: 20 Ready-to-Teach Lessons',
]

export const bonusList = [
  'Bonus 1 — 150 Swimming Drills Library',
  'Bonus 2 — 100 Swimming Mistakes, Teaching Cues & Corrections',
  'Bonus 3 — 50 Ready-to-Teach Swim Games & Fun Lessons',
  'Bonus 4 — Swimmer Assessment, Skill Level & Progress Tracking System',
  'Bonus 5 — 40 Emergency Lessons, Small-Group & Limited-Equipment Plans',
]

export const alsoIncluded = [
  '120 Ready-to-Teach Lessons',
  'Instant Digital Access',
  'PDF Format — Ready to Use',
  '7-Day Money-Back Guarantee',
]
